module.exports = __webpack_public_path__ + "img/logo.d8827c9e.svg";